<template>
<div class="error-bg">
    <!-- Error container starts -->
    <div class="error-container">

    <h1 class="mb-4 lh-1">404</h1>
    <h3 class="fw-light mb-4 text-dark">
        We're sorry but it looks <br>like that page doesn't exist
        anymore.
    </h3>
    <a href="index.html" class="btn btn-dark px-4 py-2 fs-5"><i class="ri-arrow-left-line lh-1 me-2"></i> Back to
        Home</a>

    </div>
    <!-- Error container ends -->
</div>
</template>
